import { COUNTRY_CODE } from '@constants/common.constants';
import { MaintenanceNoticeMessage, MaintenanceType } from '@constants/maintenance.constants';
import { IFirebaseMaintenanceData, IMaintenanceInfo } from '@interfaces/maintenance';
import { IUser } from '@/state/interface';

interface IMaintenanceNotice {
	title: string;
	message: string;
}

export const generateMaintenanceNotice = (type: MaintenanceType): IMaintenanceNotice => {
	const notice = MaintenanceNoticeMessage[type];
	return { title: notice.title, message: notice.message };
};

export const checkOtherMaintenanceType = (maintenanceInfo: IMaintenanceInfo): IMaintenanceNotice | false => {
	const { isDown, isScheduled } = maintenanceInfo;
	if (!isDown) return false;
	const maintenanceType = isScheduled ? MaintenanceType.PLANNED : MaintenanceType.UNPLANNED;
	return generateMaintenanceNotice(maintenanceType);
};

export const checkCardPaymentMaintenance = (maintenanceInfo: IFirebaseMaintenanceData, user: IUser): IMaintenanceNotice | false => {
	const country = user.merchant?.countryCode as COUNTRY_CODE.AU | COUNTRY_CODE.SG;
	const countryCardPayment = maintenanceInfo.cardPayment[country];

	if (!user.merchant?.earn || !countryCardPayment?.isDown) {
		return false;
	}

	return generateMaintenanceNotice(MaintenanceType.CARD_PAYMENT);
};

export const checkBlockchainMaintenance = (maintenanceInfo: IFirebaseMaintenanceData): IMaintenanceNotice | false => {
	const { isDown } = maintenanceInfo?.blockchain;
	if (!isDown) return false;
	return generateMaintenanceNotice(MaintenanceType.BLOCKCHAIN);
};

export const checkMaintenance = (maintenanceData: IFirebaseMaintenanceData, user: IUser): IMaintenanceNotice | undefined => {
	for (const type in maintenanceData) {
		let result: IMaintenanceNotice | false;
		switch (type) {
			case MaintenanceType.BLOCKCHAIN:
				result = checkBlockchainMaintenance(maintenanceData);
				break;
			case MaintenanceType.CARD_PAYMENT:
				result = checkCardPaymentMaintenance(maintenanceData, user);
				break;
			default:
				result = checkOtherMaintenanceType(maintenanceData[type as keyof Omit<IFirebaseMaintenanceData, 'cardPayment'>]);
		}
		
		if (result) return result;
	}
	return undefined;
};
